<template>
  <article class="newsletter">
    <header>
      <h1 class="title">{{ $dt(title) }}</h1>
      <i18n tag="p" class="subtitle" path="postDateFormat">
        <template v-slot:day>{{ posted.day }}</template>
        <template v-slot:month>{{
          $t(`monthNames[${posted.month - 1}]`)
        }}</template>
        <template v-slot:year>{{ posted.year }}</template>
      </i18n>
    </header>
    <main>
      <Newsletter :blocks="blocks" />
    </main>
  </article>
</template>
<script>
import Newsletter from "../Newsletter.vue";
import data from "./data.json";
import dynamicLocalization from "../../../mixins/dynamic-localization";

export default {
  mixins: [dynamicLocalization],
  components: {
    Newsletter,
  },
  data() {
    return data;
  },
};
</script>
<i18n src="../i18n.json" />
